import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\Studio\PassportTokenController::index
* @see Http/Controllers/Web/Studio/PassportTokenController.php:18
* @route '/studio/{team}/tokens'
*/
export const index = (args: { team: string | number | { slug: string | number } } | [team: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/studio/{team}/tokens',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Web\Studio\PassportTokenController::index
* @see Http/Controllers/Web/Studio/PassportTokenController.php:18
* @route '/studio/{team}/tokens'
*/
index.url = (args: { team: string | number | { slug: string | number } } | [team: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { team: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { team: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            team: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        team: typeof args.team === 'object'
        ? args.team.slug
        : args.team,
    }

    return index.definition.url
            .replace('{team}', parsedArgs.team.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\PassportTokenController::index
* @see Http/Controllers/Web/Studio/PassportTokenController.php:18
* @route '/studio/{team}/tokens'
*/
index.get = (args: { team: string | number | { slug: string | number } } | [team: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\PassportTokenController::index
* @see Http/Controllers/Web/Studio/PassportTokenController.php:18
* @route '/studio/{team}/tokens'
*/
index.head = (args: { team: string | number | { slug: string | number } } | [team: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Web\Studio\PassportTokenController::index
* @see Http/Controllers/Web/Studio/PassportTokenController.php:18
* @route '/studio/{team}/tokens'
*/
const indexForm = (args: { team: string | number | { slug: string | number } } | [team: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\PassportTokenController::index
* @see Http/Controllers/Web/Studio/PassportTokenController.php:18
* @route '/studio/{team}/tokens'
*/
indexForm.get = (args: { team: string | number | { slug: string | number } } | [team: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\PassportTokenController::index
* @see Http/Controllers/Web/Studio/PassportTokenController.php:18
* @route '/studio/{team}/tokens'
*/
indexForm.head = (args: { team: string | number | { slug: string | number } } | [team: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Web\Studio\PassportTokenController::store
* @see Http/Controllers/Web/Studio/PassportTokenController.php:42
* @route '/studio/{team}/tokens'
*/
export const store = (args: { team: string | number | { slug: string | number } } | [team: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/studio/{team}/tokens',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Web\Studio\PassportTokenController::store
* @see Http/Controllers/Web/Studio/PassportTokenController.php:42
* @route '/studio/{team}/tokens'
*/
store.url = (args: { team: string | number | { slug: string | number } } | [team: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { team: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { team: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            team: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        team: typeof args.team === 'object'
        ? args.team.slug
        : args.team,
    }

    return store.definition.url
            .replace('{team}', parsedArgs.team.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\PassportTokenController::store
* @see Http/Controllers/Web/Studio/PassportTokenController.php:42
* @route '/studio/{team}/tokens'
*/
store.post = (args: { team: string | number | { slug: string | number } } | [team: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\Studio\PassportTokenController::store
* @see Http/Controllers/Web/Studio/PassportTokenController.php:42
* @route '/studio/{team}/tokens'
*/
const storeForm = (args: { team: string | number | { slug: string | number } } | [team: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\Studio\PassportTokenController::store
* @see Http/Controllers/Web/Studio/PassportTokenController.php:42
* @route '/studio/{team}/tokens'
*/
storeForm.post = (args: { team: string | number | { slug: string | number } } | [team: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Web\Studio\PassportTokenController::destroy
* @see Http/Controllers/Web/Studio/PassportTokenController.php:52
* @route '/studio/{team}/tokens/{token}'
*/
export const destroy = (args: { team: string | number | { slug: string | number }, token: string | number } | [team: string | number | { slug: string | number }, token: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/studio/{team}/tokens/{token}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Web\Studio\PassportTokenController::destroy
* @see Http/Controllers/Web/Studio/PassportTokenController.php:52
* @route '/studio/{team}/tokens/{token}'
*/
destroy.url = (args: { team: string | number | { slug: string | number }, token: string | number } | [team: string | number | { slug: string | number }, token: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            team: args[0],
            token: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        team: typeof args.team === 'object'
        ? args.team.slug
        : args.team,
        token: args.token,
    }

    return destroy.definition.url
            .replace('{team}', parsedArgs.team.toString())
            .replace('{token}', parsedArgs.token.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\PassportTokenController::destroy
* @see Http/Controllers/Web/Studio/PassportTokenController.php:52
* @route '/studio/{team}/tokens/{token}'
*/
destroy.delete = (args: { team: string | number | { slug: string | number }, token: string | number } | [team: string | number | { slug: string | number }, token: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Web\Studio\PassportTokenController::destroy
* @see Http/Controllers/Web/Studio/PassportTokenController.php:52
* @route '/studio/{team}/tokens/{token}'
*/
const destroyForm = (args: { team: string | number | { slug: string | number }, token: string | number } | [team: string | number | { slug: string | number }, token: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\Studio\PassportTokenController::destroy
* @see Http/Controllers/Web/Studio/PassportTokenController.php:52
* @route '/studio/{team}/tokens/{token}'
*/
destroyForm.delete = (args: { team: string | number | { slug: string | number }, token: string | number } | [team: string | number | { slug: string | number }, token: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const tokens = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    destroy: Object.assign(destroy, destroy),
}

export default tokens